<!-- <div class="example-loading-shade" *ngIf="isLoadingResults">
<mat-spinner [style.zoom]="1" *ngIf="isLoadingResults"></mat-spinner>
</div> -->
<div id="contacts" class="con page-layout simple left-sidebar inner-sidebar inner-scroll w-full">
  <!-- HEADER -->
  <!-- <div class="header business_head_tab accent p-4 p-sm-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
  <div fxLayout="row" fxLayoutAlign="start center">
    <div class="logo" fxLayout="row" fxLayoutAlign="start center">
      <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
        {{ForDataBind}}
      </span>
    </div>
  </div>
  <div class="ml-sm-32" fxLayout="row" fxLayoutAlign="center center" fxFlex>
  </div>
</div> -->
  <div class="content">
    <!-- SIDEBAR -->
    <!-- <fuse-sidebar
            class="sidebar"
            name="contacts-main-sidebar"
            position="left"
            lockedOpen="gt-sm"
        > -->
    <!-- SIDEBAR CONTENT -->
    <div class="content" style="height: 100%">
      <div class="sidebar-content">
        <div class="card">
          <div class="content sidebar-scrollwrap">
            <div class="nav material2">
              <div class="nav-item name text-xs" aria-label="inbox">
                <a
                  (click)="clickedBtn !== 'name' ? loading_fun() : null"
                  [routerLink]="'/system-setting/name'"
                  (click)="chnageUrlFunction('name', 'Name')"
                  class="nav-link"
                  matRipple
                  [ngClass]="{
                    'active accent': clickedBtn === 'name',
                  }"
                >
                  <span class="title">Organisational Details</span>
                </a>
              </div>
              <div class="nav-item business" aria-label="frequently contacted">
                <!-- [routerLink]="'/system-setting/business'" <button [queryParams]="{ calander: 'business' }"></button> -->
                <a
                  (click)="clickedBtn !== 'business' ? loading_fun() : null"
                  [routerLink]="'/system-setting/business'"
                  (click)="chnageUrlFunction('business', 'Business')"
                  class="nav-link"
                  matRipple
                  [ngClass]="{
                    'active accent': clickedBtn === 'business',
                  }"
                >
                  <div class="title">Business Setup</div>
                </a>
              </div>
              @if (
                ('Fixed Fee Items' | tierPermission: 'Fixed Fee Items') &&
                ('Fixed Fee Items' | tierPermission: 'Fixed Fee Items').ALLOWED == 1
              ) {
                <div class="nav-item trust" aria-label="starred">
                  <button
                    [ngClass]="appPermissions?.[30]?.Access == 0 ? 'disabled-click-cursor' : ''"
                    class="nav-link-btn"
                    (click)="targetNewTab('/system-setting/activities', 'ACTIVITIES')"
                    mat-menu-item
                  >
                    <a
                      (click)="clickedBtn !== 'activities' ? loading_fun() : null"
                      class="nav-link"
                      matRipple
                      [ngClass]="{
                        'active accent': clickedBtn === 'activities',
                      }"
                      (click)="chnageUrlFunction('activities', 'Activities & Sundries')"
                    >
                      <div class="title">Fixed Fees & Sundries</div>
                    </a>
                  </button>
                </div>
              }
              <div class="nav-item trust" aria-label="starred">
                <a
                  (click)="clickedBtn !== 'lookups' ? loading_fun() : null"
                  [routerLink]="'/system-setting/lookups'"
                  (click)="chnageUrlFunction('lookups', 'Lookups')"
                  class="nav-link"
                  matRipple
                  [ngClass]="{
                    'active accent': clickedBtn === 'lookups',
                  }"
                >
                  <div class="title">Lookups</div>
                </a>
              </div>
              <div class="nav-item business" aria-label="frequently contacted">
                <!-- [routerLink]="'/system-setting/business'" <button [queryParams]="{ calander: 'business' }"></button> -->
                <a
                  (click)="clickedBtn !== 'account' ? loading_fun() : null"
                  [routerLink]="'/system-setting/account'"
                  (click)="chnageUrlFunction('account', 'Account')"
                  class="nav-link"
                  matRipple
                  [ngClass]="{
                    'active accent': clickedBtn === 'account',
                  }"
                >
                  <div class="title">Default Accounts</div>
                </a>
              </div>
              <div class="nav-item trust" aria-label="starred">
                <a
                  (click)="clickedBtn !== 'interest-rates' ? loading_fun() : null"
                  [routerLink]="'/system-setting/interest-rates'"
                  (click)="chnageUrlFunction('interest-rates', 'Interest Rates')"
                  class="nav-link"
                  matRipple
                  [ngClass]="{
                    'active accent': clickedBtn === 'interest-rates',
                  }"
                >
                  <div class="title">Interest Rates</div>
                </a>
              </div>
              <div class="nav-item trust" aria-label="starred">
                <a
                  (click)="clickedBtn !== 'exchange-rates' ? loading_fun() : null"
                  [routerLink]="'/system-setting/exchange-rates'"
                  (click)="chnageUrlFunction('exchange-rates', 'Exchange Rates')"
                  class="nav-link"
                  matRipple
                  [ngClass]="{
                    'active accent': clickedBtn === 'exchange-rates',
                  }"
                >
                  <div class="title">Exchange Rates</div>
                </a>
              </div>
              <!-- <div *ngIf="'' | productType" class="nav-item defaults" aria-label="starred">
              <a (click)="clickedBtn !=='matterRate'?loading_fun():null" [routerLink]="'/system-setting/matter-class-rates'" (click)="chnageUrlFunction('matterRate','Matter Class Rates')" class="nav-link" matRipple [ngClass]="{'active accent':clickedBtn ==='matterRate'}">
                <div class="title">Matter Class Rate</div>
              </a>
            </div>

            <div class="nav-item defaults" aria-label="starred">
              <a (click)="clickedBtn !=='defaults'?loading_fun():null" [routerLink]="'/system-setting/defaults'" (click)="chnageUrlFunction('defaults','Defaults')" class="nav-link" matRipple [ngClass]="{'active accent':clickedBtn ==='defaults'}">
                <div class="title">Defaults</div>
              </a>
            </div>
            <div class="nav-item estimate" aria-label="starred">
              <a (click)="clickedBtn !=='estimate'?loading_fun():null" [routerLink]="'/system-setting/estimates'" (click)="chnageUrlFunction('estimate','Estimates')" class="nav-link" matRipple [ngClass]="{'active accent':clickedBtn ==='estimate'}">
                <div class="title">Estimates</div>
              </a>
            </div>
            <div class="nav-item reginoal" aria-label="starred">
              <a (click)="clickedBtn !=='regional'?loading_fun():null" [routerLink]="'/system-setting/regional'" (click)="chnageUrlFunction('regional','Regional Settings')" class="nav-link" matRipple [ngClass]="{'active accent':clickedBtn ==='regional'}">
                <div class="title">Regional Settings</div>
              </a>
            </div>
            <div class="nav-item trust" aria-label="starred" *ngIf="currentUSer.PRODUCTTYPE != 'Barrister'">
              <a (click)="clickedBtn !=='trust'?loading_fun():null" [routerLink]="'/system-setting/trust'" (click)="chnageUrlFunction('trust','Trust')" class="nav-link" matRipple [ngClass]="{'active accent':clickedBtn ==='trust'}">
                <div class="title">Trust</div>
              </a>
            </div> -->
              <!-- <div class="nav-item trust" aria-label="starred">
            <a (click)="clickedBtn !=='xeroIntegration'?loading_fun():null" [routerLink]="'/system-setting/xero-integration'" (click)="chnageUrlFunction('xeroIntegration','Xero Integration Settings')" class="nav-link" matRipple [ngClass]="{'active accent':clickedBtn ==='xeroIntegration'}">
              <div class="title">Xero Integration</div>
            </a>
          </div>
          <div class="nav-item trust" aria-label="starred">
            <a (click)="clickedBtn !=='SilqPay'?loading_fun():null" [routerLink]="'/system-setting/SilqPay'" (click)="chnageUrlFunction('SilqPay','SILQ Pay Settings')" class="nav-link" matRipple [ngClass]="{'active accent':clickedBtn ==='SilqPay'}">
              <div class="title">SilqPay</div>
            </a>
          </div> -->

              @if (
                ('Automated Tasks' | tierPermission: 'Automated Tasks') &&
                ('Automated Tasks' | tierPermission: 'Automated Tasks').ALLOWED == 1
              ) {
                <div class="nav-item email-signature" aria-label="starred">
                  <a
                    (click)="clickedBtn !== 'workflow' ? loading_fun() : null"
                    [routerLink]="'/system-setting/workflow'"
                    (click)="chnageUrlFunction('workflow', 'Workflow')"
                    class="nav-link"
                    matRipple
                    [ngClass]="{
                      'active accent': clickedBtn === 'workflow',
                    }"
                  >
                    <div class="title">WorkFlow</div>
                  </a>
                </div>
              }

              <div class="nav-item template" aria-label="starred">
                <a
                  (click)="clickedBtn !== 'templates' ? loading_fun() : null"
                  [routerLink]="'/system-setting/templates'"
                  (click)="chnageUrlFunction('templates', 'Templates')"
                  class="nav-link"
                  matRipple
                  [ngClass]="{
                    'active accent': clickedBtn === 'templates',
                  }"
                >
                  <div class="title">Templates</div>
                </a>
              </div>
              <div class="nav-item statements" aria-label="starred">
                <a
                  (click)="clickedBtn !== 'statements' ? loading_fun() : null"
                  [routerLink]="'/system-setting/statements'"
                  (click)="chnageUrlFunction('statements', 'Statement Settings')"
                  class="nav-link"
                  matRipple
                  [ngClass]="{
                    'active accent': clickedBtn === 'statements',
                  }"
                >
                  <div class="title">Statements</div>
                </a>
              </div>
              <div class="nav-item statements" aria-label="starred">
                <a
                  (click)="clickedBtn !== 'invoice-options' ? loading_fun() : null"
                  [routerLink]="'/system-setting/invoice-options'"
                  (click)="chnageUrlFunction('invoice-options', 'Invoice Options Template')"
                  class="nav-link"
                  matRipple
                  [ngClass]="{
                    'active accent': clickedBtn === 'invoice-options',
                  }"
                >
                  <div class="title">Invoice Templates</div>
                </a>
              </div>
              <div class="nav-item name text-xs" aria-label="integrations">
                <a
                  (click)="clickedBtn !== 'searchProvider' ? loading_fun() : null"
                  [routerLink]="'/system-setting/search-provider'"
                  (click)="chnageUrlFunction('searchProvider', 'Searching Settings')"
                  class="nav-link"
                  matRipple
                  [ngClass]="{
                    'active accent': clickedBtn === 'searchProvider',
                  }"
                >
                  <span class="title">Integrations</span>
                </a>
              </div>
              <!-- <div class="nav-item name text-xs" aria-label="aml-ctf" *ngIf="accessTierPermission[2]?.ALLOWED == 1">
          <a (click)="clickedBtn !=='aml-ctf'?loading_fun():null" [routerLink]="'/system-setting/aml-ctf'" (click)="chnageUrlFunction('aml-ctf','AML/CTF Settings')" class="nav-link" matRipple [ngClass]="{'active accent':clickedBtn ==='aml-ctf'}">
            <span class="title"> AML/CTF</span>
          </a>
        </div> -->
              <!-- <div class="nav-item trust" aria-label="starred">
        <a (click)="clickedBtn !=='email-configuration'?loading_fun():null" [routerLink]="'/system-setting/email-configuration'" (click)="chnageUrlFunction('email-configuration','Email Configuration')" class="nav-link" matRipple [ngClass]="{'active accent':clickedBtn ==='email-configuration'}">
          <div class="title">Email Configuration</div>
        </a>
      </div> -->
              <!-- <div class="nav-item email-signature" aria-label="starred">
      <a  [ngClass]="appPermissions[29]?.Access==0 ? 'disabled-click-cursor' : ''" (click)="clickedBtn !=='users'?loading_fun():null" [routerLink]="'/system-setting/users'" (click)="chnageUrlFunction('users','Users')" class="nav-link" matRipple [ngClass]="{'active accent':clickedBtn ==='users'}">
        <div class="title">Users</div>
      </a>
    </div> -->
              <!-- <div class="nav-item email-signature" aria-label="starred">
    <button [ngClass]="appPermissions[29]?.Access==0 ? 'disabled-click-cursor' : ''" class="nav-link-btn btn-link">
      <a (click)="clickedBtn !=='users'?loading_fun():null" [routerLink]="'/system-setting/users'" (click)="chnageUrlFunction('users','Users')" class="nav-link" matRipple [ngClass]="{'active accent':clickedBtn ==='users'}">
        <div class="title">Users</div>
      </a>
    </button>
  </div> -->

              <div class="nav-item email-signature" aria-label="starred">
                <button
                  class="nav-link-btn"
                  [routerLink]="'/system-setting/apiaccess'"
                  mat-menu-item
                >
                  <a
                    (click)="clickedBtn !== 'api-access' ? loading_fun() : null"
                    class="nav-link"
                    matRipple
                    [ngClass]="{ 'active accent': clickedBtn === 'api-access' }"
                    (click)="chnageUrlFunction('api-access', 'API Access')"
                  >
                    <div class="title">API Access</div>
                  </a>
                </button>
              </div>

              <div class="nav-item email-signature" aria-label="starred">
                <button
                  [ngClass]="appPermissions?.[29]?.Access == 0 ? 'disabled-click-cursor' : ''"
                  class="nav-link-btn"
                  [routerLink]="'/system-setting/users'"
                  mat-menu-item
                >
                  <a
                    (click)="clickedBtn !== 'users' ? loading_fun() : null"
                    class="nav-link"
                    matRipple
                    [ngClass]="{
                      'active accent': clickedBtn === 'users',
                    }"
                    (click)="chnageUrlFunction('users', 'Users')"
                  >
                    <div class="title">Users</div>
                  </a>
                </button>
              </div>

              <!-- <div class="nav-item email-signature" aria-label="starred">
  <a (click)="clickedBtn !=='users'?loading_fun():null" [routerLink]="'/system-setting/users/useractivity'" (click)="chnageUrlFunction('users','Users')" class="nav-link" matRipple [ngClass]="{'active accent':clickedBtn ==='users'}">
    <div class="title">User Activity</div>
  </a>
</div> -->
              <!-- <div class="nav-item email-signature " aria-label="starred">
<a [ngClass]="appPermissions[29]?.Access==0 ? 'disabled-click-cursor' : ''" (click)=" clickedBtn !=='userActivity'?loading_fun():null" [routerLink]="'/system-setting/users/useractivity'" (click)="chnageUrlFunction('userActivity','User Activity')"class="nav-link" matRipple  (click)="UserActivityClick();" [ngClass]="{'active accent': clickedBtn ==='userActivity'}">
  <div class="title">User Activity</div>
</a>
</div> -->

              <!-- <div class="nav-item email-signature user" aria-label="starred">
<button [ngClass]="appPermissions[29]?.Access==0 ? 'disabled-click-cursor' : ''" class="nav-link-btn btn-link" >
  <a  (click)=" clickedBtn !=='userActivity'?loading_fun():null" [routerLink]="'/system-setting/users/useractivity'" (click)="chnageUrlFunction('userActivity','User Activity')"class="nav-link" matRipple  (click)="UserActivityClick();" [ngClass]="{'active accent': clickedBtn ==='userActivity'}">
    <div class="title">User Activity</div>
  </a>
</button>
</div> -->

              <!-- <div class="nav-item email-signature user" aria-label="starred">
<button [ngClass]="appPermissions[29]?.Access==0 ? 'disabled-click-cursor' : ''" class="nav-link-btn" [routerLink]="'/system-setting/users/useractivity'"   mat-menu-item>
  <a (click)=" clickedBtn !=='userActivity'?loading_fun():null" class="nav-link" matRipple [ngClass]="{'active accent': clickedBtn ==='userActivity'}" (click)="chnageUrlFunction('userActivity','User Activity')">
    <div class="title">User Activity</div>
  </a>
</button>
</div> -->
              <div class="nav-item business" aria-label="frequently contacted">
                <!-- [routerLink]="'/system-setting/business'" <button [queryParams]="{ calander: 'business' }"></button> -->
                <a
                  (click)="clickedBtn !== 'account-management' ? loading_fun() : null"
                  [routerLink]="'/system-setting/account-management/basicinfo'"
                  (click)="chnageUrlFunction('account-management', 'Account Management')"
                  class="nav-link"
                  matRipple
                  [ngClass]="{
                    'active accent': clickedBtn === 'account-management',
                  }"
                >
                  <div class="title">Subscription & Billing</div>
                </a>
              </div>

              <!-- <div class="nav-item statements" aria-label="starred">
<a (click)="chnageUrlFunction('/system-setting/miscellaneous','miscellaneous','miscellaneous Settings')" class="nav-link" matRipple [ngClass]="{'active accent':clickedBtn ==='miscellaneous'}">
  <div class="title">Miscellaneous</div>
</a>
</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </fuse-sidebar> -->
    <!-- <div class="center p-24" > -->
    <div class="center px-10! pt-10! pb-2!">
      <!-- <div class="example-containerdata"> -->
      <div class="content position-relative">
        <form name="form" [formGroup]="SettingForm">
          @if (clickedBtn === 'name') {
            <app-name [errorWarningData]="errorWarningData" [SettingForm]="SettingForm"></app-name>
          }
          @if (clickedBtn === 'business') {
            <app-business
              [errorWarningData]="errorWarningData"
              (myOutput)="GetChildData($event)"
              [SettingForm]="SettingForm"
            ></app-business>
          }
          @if (clickedBtn === 'defaults') {
            <app-defaults
              [errorWarningData]="errorWarningData"
              [SettingForm]="SettingForm"
            ></app-defaults>
          }
          @if (clickedBtn === 'estimate') {
            <app-estimates-setting
              [errorWarningData]="errorWarningData"
              [SettingForm]="SettingForm"
            ></app-estimates-setting>
          }
          @if (clickedBtn === 'regional') {
            <app-reginoal-setting
              [errorWarningData]="errorWarningData"
              [SettingForm]="SettingForm"
            ></app-reginoal-setting>
          }
          @if (clickedBtn === 'trust') {
            <app-trust
              [errorWarningData]="errorWarningData"
              [SettingForm]="SettingForm"
            ></app-trust>
          }
          @if (clickedBtn === 'templates') {
            <app-templates
              [errorWarningData]="errorWarningData"
              [SettingForm]="SettingForm"
              (saveSettingData)="systemSettingRef($event)"
            ></app-templates>
          }
          @if (clickedBtn === 'account') {
            <app-account></app-account>
          }
          @if (clickedBtn === 'account-management') {
            <app-account-managment></app-account-managment>
          }
          @if (clickedBtn === 'interest-rates') {
            <app-interst-rates
              (callLoading)="loading_fun()"
              [SettingForm]="SettingForm"
            ></app-interst-rates>
          }
          @if (clickedBtn === 'exchange-rates') {
            <app-exchange-rates [SettingForm]="SettingForm"></app-exchange-rates>
          }
          @if (clickedBtn === 'matterRate') {
            <app-matter-rates [SettingForm]="SettingForm"></app-matter-rates>
          }
          @if (clickedBtn === 'searchProvider') {
            <app-search-provider
              [errorWarningData]="errorWarningData"
              [SettingForm]="SettingForm"
            ></app-search-provider>
          }
          <!-- <app-aml-ctf-setting [errorWarningData]="errorWarningData" [SettingForm]="SettingForm" *ngIf="clickedBtn ==='aml-ctf'"></app-aml-ctf-setting> -->
          @if (clickedBtn === 'xeroIntegration') {
            <app-xero-integration
              [errorWarningData]="errorWarningData"
              [SettingForm]="SettingForm"
            ></app-xero-integration>
          }
          @if (clickedBtn === 'SilqPay') {
            <app-silqpay
              [errorWarningData]="errorWarningData"
              [silqPayDrop]="silqPayDrop"
              [SettingForm]="SettingForm"
            ></app-silqpay>
          }
          @if (clickedBtn === 'statements') {
            <app-statements
              [errorWarningData]="errorWarningData"
              [SettingForm]="SettingForm"
            ></app-statements>
          }
          @if (clickedBtn === 'lookups') {
            <app-lookups
              [errorWarningData]="errorWarningData"
              [SettingForm]="SettingForm"
            ></app-lookups>
          }
          <!-- <app-miscellaneous [errorWarningData]="errorWarningData" [SettingForm]="SettingForm" *ngIf="clickedBtn ==='miscellaneous'"></app-miscellaneous> -->
          @if (clickedBtn === 'activities') {
            <div>
              <!-- <div class="activity-menu">
                            <div class="activity-icon">
                                <button class="nav-link-btn activity-btn" [ngClass]="appPermissions[30]?.Create==0 ? 'disabled-click large-button' : 'large-button'" (click)="ActivitySundryDialog('new')">
                                <mat-icon class="main-icon">
                                    <img src="assets/icons/web_app/icon_time_cost_new_d.ico">
                                </mat-icon>
                                <div class="main-text activity-icon-text">
                                    <span>New Activity</span>
                                </div>
                                </button>
                            </div>
                            <div class="activity-icon">
                                <button class="nav-link-btn activity-btn" [ngClass]="(appPermissions[30]?.Edit==0 || isActivityData=='empty')? 'disabled-click large-button' : 'large-button'" (click)="ActivitySundryDialog('edit')">
                                <mat-icon class="main-icon">
                                    <img src="assets/icons/web_app/icon_time_cost_edit_d.ico">
                                </mat-icon>
                                <div class="main-text activity-icon-text">
                                    <span>Edit Activity</span>
                                </div>
                                </button>
                            </div>
                            <div class="activity-icon">
                                <button class="nav-link-btn activity-btn" [ngClass]="(appPermissions[30]?.Delete==0 || isActivityData =='empty') ? 'disabled-click large-button' : 'large-button'" (click)="DeleteActivityDialog()">
                                <mat-icon class="main-icon">
                                    <img src="assets/icons/web_app/icon_time_cost_delete_d.ico">
                                </mat-icon>
                                <div class="main-text activity-icon-text">
                                    <span>Delete Activity</span>
                                </div>
                                </button>
                            </div>
                            <div class="activity-icon">
                                <button class="nav-link-btn activity-btn"  [ngClass]="(appPermissions[30]?.Create==0 || isActivityData=='empty') ? 'disabled-click large-button' : 'large-button'" (click)="ActivitySundryDialog('Duplicate')">
                                <mat-icon class="main-icon">
                                    <img src="assets/icons/web_app/icon_duplicate_d.ico">
                                </mat-icon>
                                <div class="main-text activity-icon-text">
                                    <span>Duplicate Activity</span>
                                </div>
                                </button>
                            </div>
                            </div> -->
              <div>
                <app-activities
                  (addActivity)="addActivities($event)"
                  (addDuplicateActivity)="addDuplicateActivities($event)"
                ></app-activities>
              </div>
            </div>
          }

          @if (clickedBtn === 'email-signature') {
            <app-email-signature></app-email-signature>
          }
          <!-- <app-email-configuration *ngIf="clickedBtn ==='email-configuration'"></app-email-configuration> -->
          @if (clickedBtn === 'invoice-options') {
            <app-invoice-options
              [errorWarningData]="errorWarningData"
              [SettingForm]="SettingForm"
            ></app-invoice-options>
          }
          @if (clickedBtn === 'api-access') {
            <app-apiaccess
              [errorWarningData]="errorWarningData"
              [SettingForm]="SettingForm"
            ></app-apiaccess>
          }
          @if (clickedBtn === 'users') {
            <app-users></app-users>
          }
          @if (clickedBtn === 'userActivity') {
            <app-user-activity></app-user-activity>
          }
          @if (clickedBtn === 'workflow') {
            <app-tasks-pack></app-tasks-pack>
          }
        </form>
        <!-- <mat-dialog-actions  align="end" class="popup_ftr position-system" *ngIf="clickedBtn !='email-signature' && clickedBtn !='email-configuration' && clickedBtn !='activities' && clickedBtn !=='invoice-options' && clickedBtn !=='users' && clickedBtn !== 'userActivity' && clickedBtn !=='lookups' && clickedBtn !=='interest-rates' && clickedBtn !=='exchange-rates' && clickedBtn !=='account-management'"> -->

        <!-- <mat-dialog-actions  align="end" class="popup_ftr" *ngIf="clickedBtn !='email-signature' && clickedBtn !='email-configuration' && clickedBtn !='activities' && clickedBtn !=='invoice-options' && clickedBtn !=='users' && clickedBtn !== 'userActivity' && clickedBtn !=='lookups' && clickedBtn !=='interest-rates' && clickedBtn !=='exchange-rates' && clickedBtn !=='account-management'">
  <button id="callApiId" class="mainbtn_size" mat-raised-button color="accent" [disabled]="isspiner" (click)="save()">
    <mat-spinner *ngIf="isspiner"></mat-spinner>Save
  </button>
</mat-dialog-actions> -->
        <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
      </div>
      <!-- <mat-dialog-actions align="end" class="popup_ftr" *ngIf="clickedBtn !='email-signature' && clickedBtn !='email-configuration' && clickedBtn !='activities' && clickedBtn !=='invoice-options' && clickedBtn !=='users' && clickedBtn !== 'userActivity'">
<button class="mainbtn_size" mat-raised-button color="accent" [disabled]="isspiner" (click)="save()">
  <mat-spinner *ngIf="isspiner"></mat-spinner>Save
</button>
<button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button>
</mat-dialog-actions> -->
    </div>
  </div>
</div>
